import { Field, Formik } from "formik"
import { useEffect, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import * as Yup from 'yup';
import Post from "../api/Post";
import { ACCOUNT_ACTIVE_ALL, COUNTRY_ACTIVE_ALL, LANGUAGE_ACTIVE_ALL, MARITAL_STATUS_ACTIVE_ALL, PACIENTES_ADD, RELIGIONES_ACTIVE_ALL } from "../api/Routes";
import moment from 'moment'
import Get from "../api/Get";
import { withTranslation } from "react-i18next";
import PhoneInput from 'react-phone-input-2'
import es from 'react-phone-input-2/lang/es.json'
import 'react-phone-input-2/lib/style.css'

function  RegisterForm({t, setLogin}) {
    const [error, setError] = useState(null)
    const [maritalStatusOpt, setMaritalStatusOpt] = useState([])
    const [countryOpt, setCountryOpt] = useState([])
    const [gender, setGender] = useState('')
    const [religionOpt, setReligionOpt] = useState([])
    const [tipoSangre, setTipoSangre] = useState('')
    const [languageOpt, setLanguageOpt] = useState([])
    const [accountOpt, setAccountOpt] = useState([])
    const message = t('PoliticaRegistrarseCosto')


    const [initialValues, setInitialValues] = useState({
        id: '',
        name: '',
        lastName: '',
        gender: '',
        dateOfBirthday: '',
        maritalStatus: '',
        nationality: '',
        phoneNumber: '',
        email: '',
        country: '',
        religion: '',
        bloodType: '',
        occupation:'',
        language: '',
        address: '',
        allergies: '',
        account: '',
        company: '',
        medicalHistory: '',
        externalId: '',
        password: '',
        hasafiliacion: ''
    })

    useEffect(()=>{
        Get({url: ACCOUNT_ACTIVE_ALL, noToken: true})
        .then(response=>{
            setAccountOpt(response.data)
        })
        Get({url: COUNTRY_ACTIVE_ALL, noToken: true})
        .then(response=>{            
            setCountryOpt(response.data)
        })
        Get({url: LANGUAGE_ACTIVE_ALL, noToken: true})
        .then(response=>{
            setLanguageOpt(response.data)
        })
        Get({url: MARITAL_STATUS_ACTIVE_ALL, noToken: true})
        .then(response=>{
            setMaritalStatusOpt(response.data)
        })
        Get({url: RELIGIONES_ACTIVE_ALL, noToken: true})
        .then(response=>{
            setReligionOpt(response.data)
        })
    }, [])

    const [phone, setPhone] = useState('')

    const shema = Yup.object().shape({
        name: Yup.string()
          .required(t('Camporequerido')),
        password: Yup.string()
          .required(t('Camporequerido')),
        lastName: Yup.string()
          .required(t('Camporequerido')),
        gender: Yup.string()
          .required(t('Camporequerido')),
        // dateOfBirthday: Yup.string()
        //   .required(t('Camporequerido')),
        nationality: Yup.string()
          .required(t('Camporequerido')),
        phoneNumber: Yup.string()
          .required(t('Camporequerido'))
          .min(12,'Campo inválido')
          .max(12,'Campo inválido'),
        email: Yup.string()
           .email(t('Correoinvalido'))
           .required(t('Camporequerido')),
        maritalStatus: Yup.string()
           .required(t('Camporequerido')),
        country: Yup.string()
           .required(t('Camporequerido')),
        religion: Yup.string()
           .required(t('Camporequerido')),
        bloodType: Yup.string()
          .required(t('Camporequerido')),
        // occupation: Yup.string()
        //   .required(t('Camporequerido')),
        language: Yup.string()
           .required(t('Camporequerido')),
        // address: Yup.string()
        //   .required(t('Camporequerido')),
        // allergies: Yup.string()
        //   .required(t('Camporequerido')),
        // company: Yup.string()
        //    .required(t('Camporequerido')),
        account: Yup.string().when("hasafiliacion", {
            is: 'SI',
            then: Yup.string()
                  .required(t('Camporequerido')),
            otherwise: Yup.string().notRequired(),
        }),
        hasafiliacion: Yup.string()
          .required(t('Camporequerido')),
    });


    return(
        <Formik
            initialValues={initialValues}
            validationSchema={shema}
            onSubmit={(values, { setSubmitting,setFieldValue }) => { 
                let d = {
                    id: null,
                    account: values.account ? {id: values.account} : null,
                    address: values.address,
                    allergies: values.allergies,
                    bloodType: values.bloodType,
                    company: values.company ? {id: values.company} :  null,
                    country: {id: values.country},
                    dateOfBirthday: moment().format('DD-MM-YYYY'),
                    email: values.email,
                    gender: values.gender,
                    language: {id: values.language},
                    lastName: values.lastName,
                    maritalStatus: {id: values.maritalStatus},
                    medicalHistory: values.medicalHistory,
                    name: values.name,
                    nationality: values.nationality,
                    //newPatient: true,
                    occupation: values.occupation,
                    phoneNumber: values.phoneNumber,
                    religion: {id: values.religion},
                    externalId: values.externalId,
                    password: values.password
                }    
                console.log(d)

                Post({url: PACIENTES_ADD, data: d, header: false})
                .then(response=>{
                    setSubmitting(false)
                    setLogin(true)
                })                
                .catch(error=>{
                    setSubmitting(false)
                    console.log('error')
                    console.log(error)
                })

            }}
        >{({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            setFieldValue,
            setFieldError
        }) => (
            <Form onSubmit={handleSubmit}>
                {error && <label className="d-block text-danger text-center">{error}</label>}
                <Card className="shadow-1 mb-3">
                    <Card.Body>
                        <h6>{t('Datosgenerales')}</h6>
                        <Row className="justify-content-center mt-4">
                            <Col xs="12" md="12">
                                <Form.Group>
                                    <Form.Label className="font-weight-bold-600 text-secondary">{t('Nombre')}*</Form.Label>
                                    <Field 
                                        type="text"
                                        className={`form-control input-form ${errors.name && 'error'}`}
                                        name="name"
                                    />
                                    { errors.name && <div className="invalid-feedback d-block">{errors.name}</div> }
                                </Form.Group>                                
                            </Col>
                            <Col xs="12" md="12">
                                <Form.Group>
                                    <Form.Label className="font-weight-bold-600 text-secondary">{t('Apellidos')}*</Form.Label>
                                    <Field 
                                        type="text"
                                        className={`form-control input-form ${errors.lastName && 'error'}`}
                                        name="lastName"
                                    />
                                    { errors.lastName && <div className="invalid-feedback d-block">{errors.lastName}</div> }
                                </Form.Group>
                            </Col>
                            <Col xs="12" md="12">
                                <Form.Group>
                                    <Form.Label className="font-weight-bold-600 text-secondary">{t('Estadocivil')}*</Form.Label>
                                    <Field 
                                        as="select"
                                        className={`form-control input-form ${errors.maritalStatus && 'error'}`}
                                        name="maritalStatus"
                                    >
                                        <option value="">{t('Seleccionar')}</option>
                                        {
                                            maritalStatusOpt.map((item,i)=>(
                                                <option value={item.id} key={i}>{item.name}</option>
                                            ))
                                        }
                                        
                                    </Field>
                                    { errors.maritalStatus && <div className="invalid-feedback d-block">{errors.maritalStatus}</div> }
                                </Form.Group>
                            </Col>
                            <Col xs="12" md="12">
                                <Form.Group>
                                    <Form.Label className="font-weight-bold-600 text-secondary">{t('Genero')}*</Form.Label>
                                    <ul className="mb-0 list-inline list-form">
                                        <li className={`${gender==='Female' && 'active'} list-inline-item cursor-pointer`} 
                                            onClick={e=>{
                                                setGender('Female')
                                                setFieldValue('gender', 'Female')
                                            }}>
                                            <span className="input-radio-custom text-color-input">{t('Femenino')}</span>
                                        </li>
                                        <li className={`${gender==='Male' && 'active'} list-inline-item cursor-pointer`} 
                                            onClick={e=>{
                                                    setGender('Male')
                                                    setFieldValue('gender', 'Male')
                                            }}>
                                            <span className="input-radio-custom text-color-input">{t('Masculino')}</span>
                                        </li>
                                    </ul>
                                    { errors.gender && <div className="invalid-feedback d-block">{errors.gender}</div> }
                                </Form.Group>
                            </Col>
                            <Col xs="12" md="12">
                                <Form.Group>
                                    <Form.Label className="font-weight-bold-600 text-secondary">{t('Nacionalidad')}*</Form.Label>
                                    <div>
                                        <label className="mr-5 text-color-input">
                                            Mexicana
                                            <Field 
                                                type="radio"
                                                name="nationality"
                                                value={t('Mexicana')}
                                                className="ml-3 radio-form"
                                            />
                                        </label>
                                        <label className="mr-5 text-color-input">
                                            Extranjera
                                            <Field 
                                                type="radio"
                                                name="nationality"
                                                value={t('Extranjera')}
                                                className="ml-3 radio-form"
                                            />
                                        </label>
                                    </div>
                                    { errors.nationality && <div className="invalid-feedback d-block">{errors.nationality}</div> }
                                </Form.Group>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
                <Card className="shadow-1">
                    <Card.Body>
                        <h6>{t('Expediente')}</h6>
                        <Row className="justify-content-center mt-4">
                            <Col xs="12" md="12">
                                <Form.Group>
                                    <Form.Label className="font-weight-bold-600 text-secondary">{t('Telefono')}*</Form.Label>
                                    <PhoneInput
                                        inputClass={`form-control input-form ${errors.phoneNumber && 'error'} w-100`}
                                        country={'mx'}
                                        countryCodeEditable={false}
                                        enableSearch={true}
                                        preferredCountries={['mx', 'co']}
                                        disableSearchIcon={true}
                                        localization={es}
                                        value={phone}
                                        onChange={(phone, country, e, formattedValue) => {
                                            setPhone(phone)
                                            setFieldValue('phoneNumber', phone)
                                            let validNumber = (country.format.match(/\./g)).length
                                            if(phone.length !== validNumber){
                                                setFieldError('phoneNumber', 'Campo inválido')
                                            }else if(phone.length === validNumber){
                                                setFieldValue('phoneNumber', phone, true)
                                            }                                                
                                        }}
                                    />
                                    { errors.phoneNumber && <div className="invalid-feedback d-block">{errors.phoneNumber}</div> }
                                </Form.Group>
                            </Col>
                            <Col xs="12" md="12">
                                <Form.Group>
                                    <Form.Label className="font-weight-bold-600 text-secondary">{t('Correoelectronico')}*</Form.Label>
                                    <Field 
                                        type="text"
                                        className={`form-control input-form ${errors.email && 'error'}`}
                                        name="email"
                                    />
                                    { errors.email && <div className="invalid-feedback d-block">{errors.email}</div> }
                                </Form.Group>
                            </Col>
                            <Col xs="12" md="12">
                                <Form.Group>
                                    <Form.Label className="font-weight-bold-600 text-secondary">{t('Contrasena')}*</Form.Label>
                                    <Field 
                                        type="password"
                                        className={`form-control input-form ${errors.password && 'error'}`}
                                        name="password"
                                    />
                                    { errors.password && <div className="invalid-feedback d-block">{errors.password}</div> }
                                </Form.Group>
                            </Col>
                            <Col xs="12" md="12">
                                <Form.Group>
                                    <Form.Label className="font-weight-bold-600 text-secondary">{t('Lugarnacimiento')}*</Form.Label>
                                    <Field 
                                        as="select"
                                        className={`form-control input-form ${errors.country && 'error'}`}
                                        name="country"
                                    >
                                        <option value="">{t('Seleccionar')}</option>
                                        {
                                            countryOpt.map((item,i)=>(
                                                <option value={item.id} key={i}>{item.name}</option>
                                            ))
                                        }
                                    </Field>
                                    { errors.country && <div className="invalid-feedback d-block">{errors.country}</div> }
                                </Form.Group>
                            </Col>
                            <Col xs="12" md="12">
                                <Form.Group>
                                    <Form.Label className="font-weight-bold-600 text-secondary">{t('Religion')}*</Form.Label>
                                    <Field 
                                        as="select"
                                        className={`form-control input-form ${errors.religion && 'error'}`}
                                        name="religion"
                                    >
                                        <option value="">{t('Seleccionar')}</option>
                                        {
                                            religionOpt.map((item,i)=>(
                                                <option value={item.id} key={i}>{item.name}</option>
                                            ))
                                        }
                                    </Field>
                                    { errors.religion && <div className="invalid-feedback d-block">{errors.religion}</div> }
                                </Form.Group>
                            </Col>
                            <Col xs="12" md="12">
                                <Form.Group>
                                    <Form.Label className="font-weight-bold-600 text-secondary">{t('Tiposangre')}*</Form.Label>
                                    <ul className="mb-0 list-inline list-form">
                                        <li className={`${tipoSangre==='O-' && 'active'} list-inline-item cursor-pointer`} 
                                            onClick={e=>{
                                                setTipoSangre('O-')
                                                setFieldValue('bloodType', 'O-')
                                            }}>
                                            <span className="input-radio-custom text-color-input">O-</span>
                                        </li>
                                        <li className={`${tipoSangre==='O+' && 'active'} list-inline-item cursor-pointer`} 
                                            onClick={e=>{
                                                setTipoSangre('O+')
                                                setFieldValue('bloodType', 'O+')
                                            }}>
                                            <span className="input-radio-custom text-color-input">O+</span>
                                        </li>
                                        <li className={`${tipoSangre==='A-' && 'active'} list-inline-item cursor-pointer`} 
                                            onClick={e=>{
                                                setTipoSangre('A-')
                                                setFieldValue('bloodType', 'A-')
                                            }}>
                                            <span className="input-radio-custom text-color-input">A-</span>
                                        </li>
                                        <li className={`${tipoSangre==='A+' && 'active'} list-inline-item cursor-pointer`} 
                                            onClick={e=>{
                                                setTipoSangre('A+')
                                                setFieldValue('bloodType', 'A+')
                                            }}>
                                            <span className="input-radio-custom text-color-input">A+</span>
                                        </li>
                                        <li className={`${tipoSangre==='AB-' && 'active'} list-inline-item cursor-pointer`} 
                                            onClick={e=>{
                                                setTipoSangre('AB-')
                                                setFieldValue('bloodType', 'AB-')
                                            }}>
                                            <span className="input-radio-custom text-color-input">AB-</span>
                                        </li>
                                        <li className={`${tipoSangre==='AB+' && 'active'} list-inline-item cursor-pointer`} 
                                            onClick={e=>{
                                                setTipoSangre('AB+')
                                                setFieldValue('bloodType', 'AB+')
                                            }}>
                                            <span className="input-radio-custom text-color-input">AB+</span>
                                        </li>
                                        <li className={`${tipoSangre==='B+' && 'active'} list-inline-item cursor-pointer`} 
                                            onClick={e=>{
                                                setTipoSangre('B+')
                                                setFieldValue('bloodType', 'B+')
                                            }}>
                                            <span className="input-radio-custom text-color-input">B+</span>
                                        </li>
                                        <li className={`${tipoSangre==='B-' && 'active'} list-inline-item cursor-pointer`} 
                                            onClick={e=>{
                                                setTipoSangre('B-')
                                                setFieldValue('bloodType', 'B-')
                                            }}>
                                            <span className="input-radio-custom text-color-input">B-</span>
                                        </li>
                                        <li className={`${tipoSangre==='desconocido' && 'active'} list-inline-item cursor-pointer`} 
                                            onClick={e=>{
                                                setTipoSangre('desconocido')
                                                setFieldValue('bloodType', 'desconocido')
                                            }}>
                                            <span className="input-radio-custom text-color-input">{t('Desconocido')}</span>
                                        </li>
                                    </ul>
                                    { errors.bloodType && <div className="invalid-feedback d-block">{errors.bloodType}</div> }
                                </Form.Group>
                            </Col>
                            <Col xs="12" md="12">
                                <Form.Group>
                                    <Form.Label className="font-weight-bold-600 text-secondary">{t('Idioma')}*</Form.Label>
                                    <Field 
                                        as="select"
                                        className={`form-control input-form ${errors.language && 'error'}`}
                                        name="language"
                                    >
                                        <option value="">{t('Seleccionar')}</option>
                                        {
                                            languageOpt.map((item,i)=>(
                                                <option value={item.id} key={i}>{item.name}</option>
                                            ))
                                        }
                                    </Field>
                                    { errors.language && <div className="invalid-feedback d-block">{errors.language}</div> }
                                </Form.Group>
                            </Col>
                            <Col xs="12" md="12">
                                <Form.Group>
                                    <Form.Label className="font-weight-bold-600 text-secondary">{t('Cuentasafiliacion')}*</Form.Label>
                                    <div>
                                        <label className="mr-5 text-color-input">
                                            {t('Si')}
                                            <Field 
                                                type="radio"
                                                name="hasafiliacion"
                                                value='SI'
                                                className="ml-3 radio-form"
                                            />
                                        </label>
                                        <label className="mr-5 text-color-input">
                                            {t('No')}
                                            <Field 
                                                type="radio"
                                                name="hasafiliacion"
                                                value='NO'
                                                className="ml-3 radio-form"
                                            />
                                        </label>
                                    </div>
                                    { errors.hasafiliacion && <div className="invalid-feedback d-block">{errors.hasafiliacion}</div> }
                                </Form.Group>
                            </Col>
                            {
                                values.hasafiliacion === 'NO' &&
                                <Col xs="12" md="12">
                                    <label className="mb-0 color-red">{message}</label>
                                </Col>
                            }
                            {values.hasafiliacion !== 'NO' && <Col xs="12" md="12">
                                <Form.Group>
                                    <Form.Label className="font-weight-bold-600 text-secondary">{t('Socio')}</Form.Label>
                                    <Field 
                                        as="select"
                                        className={`form-control input-form ${errors.company && 'error'}`}
                                        name="account"
                                    >
                                        <option value="">{t('Seleccionar')}</option>
                                        {
                                            accountOpt.map((item,i)=>(
                                                <option value={item.id} key={i}>{item.name}</option>
                                            ))
                                        }
                                    </Field>
                                    { errors.account && <div className="invalid-feedback d-block">{errors.account}</div> }
                                </Form.Group>
                            </Col>}
                        </Row>
                    </Card.Body>
                </Card>
                <Row>
                    <Col><label className="text-primary1">{t('Yatienescuenta')} <strong className="cursor-pointer" onClick={e=>setLogin(true)}>{t('Ingresaaqui')}</strong></label></Col>
                </Row>
                <Row className="justify-content-center my-3">
                    <Col xs="12" md="5">
                        <Button className="btn-login" block type="submit">
                            {
                                isSubmitting ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> :
                                t('Continuar')
                            }
                        </Button>
                    </Col>
                </Row>
            </Form>
            
        )}
        </Formik>
    )
}

export default withTranslation()(RegisterForm)